var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle2E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Woman_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_e"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M510.5,232.9c-0.4-1.1-0.8-2.2-1.3-3.2c-7.1-14.8-10-25.4-11.5-36c-0.9-6.9-1.2-13.8-1.6-21.8c-0.1-2.3-0.2-4.6-0.3-7.1 c-0.3-1.8-0.4-5.6-0.8-9.7c-0.3-3.8-0.7-7.7-1.6-10.5c0-0.1-0.1-0.2-0.1-0.3c-5.9-19.6-12.7-24.2-49.4-35.5 c-2.2-1.1-4.3-2.2-6.4-3.4c-10.3-6.2-18.7-14.5-30.1-19.2c-3.3-1.3-8.2-2.9-11.9-3.5c-23.7-5.5-49.5-0.2-66.6,16.3 c-14.1-8.8-41.9-8.6-57.1-2.7c-24.6,9.6-29.6,25.4-32.9,50.1c0,0.1,0,0.3-0.1,0.4c-0.3,2.5-1,5-1.9,7.5 c-7.1,19.6-28.8,37.5-21,58c11.8,31-0.6,35.4-2.8,59.1c-1.6,17.5,7.5,42.9,20.1,55.3c2.6,2.6,9.8,7.1,17.3,10.9 c5.6,2.9,11.2,5.7,15.2,6.7c-0.3-0.6-0.5-1.2-0.8-1.8c-0.6-1.5-1.1-3-1.6-4.6c-0.1-0.2-0.1-0.4-0.2-0.6 c-0.1-0.4-0.2-0.8-0.3-1.2c-1.7-6.9-1.9-14.2-1.3-22.1c0.4-5.3,1.1-10.6,1.8-15.9c0.1,0,0.1,0.1,0.2,0.1 c1.1-5.8,2.6-11.4,4.6-16.6c6.4-16,15.5-18,12.8-44.7c-1.6-15-16.2-37.3-2.5-50.4c10.9-10.4,23.7-11.9,33.6-27.4 c0.1,1.2,0.3,2.3,0.6,3.5c8.1,34.2,42.4,30.5,67.8,35.1c2.3,0.6,10,2.5,12,3.3c16.5,6.4,14,20.5,25.7,29 c13.2,9.6,27.6,3.8,38.2,13.9l0,0c11,8.5,18.1,22.7,21.6,33.9c-1.8,6.2-4.3,12-7.7,17.5c-2.9,4.6-10.5,11.9-17,10.1 c0.7,3.9,1.4,8.3,2,13.5c0.1,2,0.2,4.1,0.1,6.1c-0.4,23.9-17.2,41.2-35.7,55.3c0,0.3,0,0.5,0,0.6c0.1,20.7,1.3,46.1,13.3,63.7 c19.7-0.4,38-11.2,50.6-24c20.1-18.1,22.4-45.8,16.2-71.2c-1-3.6-2.2-7.2-3.7-10.6c-4.3-9.7-10.8-18.5-20.1-25 c-0.2,0.1-0.3,0.1-0.5,0.2c0.1-0.1,0.2-0.2,0.3-0.3c5.2-5.3,10.2-10.5,14.6-15.8c8.2-9.9,14.6-19.9,17.6-30.2 c1-3.6,2.1-5.9,2.6-9.6c1.1-4.1,1.6-8.7,1.6-13.3C512.3,240.6,511.7,236.6,510.5,232.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#654935",
    d: "M292.6,101.5C282.3,122,258.7,138,239,146.3c0,0.1,0,0.3-0.1,0.4c-0.3,2.5-1,5-1.9,7.5 C262.1,144.8,286.2,125.9,292.6,101.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654935",
    d: "M473.1,208.7c-7-10.5-12.9-14.9-25.6-18.9c9.4,5.8,13,9.6,18.4,16.1c5.5,6.7,8.2,15.8,14.5,21.9 c9.2,8.9,20.4,12.7,32,16.9c0-4.1-0.6-8.1-1.8-11.8C496.4,229.2,483.3,223.9,473.1,208.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654935",
    d: "M407.7,96.1c3.2,1.9,6.2,4,9.2,6.1c18.8,12,27.7,31.2,44.5,43.9c9.7,7.2,21.5,10.4,33.7,8.9 c-0.3-3.8-0.7-7.7-1.6-10.5c0-0.1-0.1-0.2-0.1-0.3c-32.5-0.2-46.7-27.6-70.9-41.7C419.3,100.7,411.6,96.9,407.7,96.1z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle2E);
export default __webpack_public_path__ + "static/media/woman_hairstyle_2e.7acfb4877d8577fabf84ced0ba39ec65.svg";
export { ForwardRef as ReactComponent };